module.exports = __webpack_public_path__ + "static/img/12.b30d863.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/12.jpg
// module id = ZFIX
// module chunks = 0